import React, { Component } from 'react';

export default function(props) {
    return <i className="glyphicon glyphicon-repeat spin"/>;
};


/** WEBPACK FOOTER **
 ** ./src/components/Loader/Loader.js
 **/